import { formatDaySchedule, type WeekSchedule } from '@/shared/lib/schedule';

/** "График работы" cell: weekdays / weekends / holidays. */
export const ScheduleCell = ({ schedule }: { schedule?: WeekSchedule }) => (
  <>
    <div>Пн - Пт: {formatDaySchedule(schedule?.weekdays)}</div>
    <div>Сб - Вс: {formatDaySchedule(schedule?.weekends)}</div>
    <div>Праздники: {formatDaySchedule(schedule?.holidays)}</div>
  </>
);
